import { Settings, Check } from "lucide-react";

interface DashboardHeaderProps {
  onSettingsClick: () => void;
  onSaveClick: () => void;
}

export const DashboardHeader = ({
  onSettingsClick,
  onSaveClick,
}: DashboardHeaderProps) => {
  return (
    <div className="bg-white py-8 px-4 shadow-sm border-b border-gray-200 pt-24">
      <div className="max-w-7xl mx-auto">
        <div className="md:flex md:items-center md:justify-between">
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl font-bold primary-text sm:text-3xl sm:truncate">
              Admin Dashboard
            </h1>
            <p className="mt-2 secondary-text">
              Configure assessment weights, manage permissions, and control
              curriculum settings.
            </p>
          </div>
          <div className="mt-4 md:mt-0 md:ml-4 flex space-x-3">
            <button
              onClick={onSettingsClick}
              className="btn btn-small btn-secondary"
            >
              <Settings className="-ml-1 mr-2 h-5 w-5" />
              Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
